import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import { authApi } from '../services/api';
import { LoadingSpinner } from '../components/common/LoadingComponents';
import { ROUTES } from '../utils/constants';

function VerifyEmailPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('verifying'); // 'verifying', 'success', 'error'
  const [message, setMessage] = useState('');

  useEffect(() => {
    const verifyEmail = async () => {
      const token = searchParams.get('token');
      
      if (!token) {
        setStatus('error');
        setMessage('Invalid verification link. No token provided.');
        return;
      }

      try {
        const response = await authApi.verifyEmail(token);
        setStatus('success');
        setMessage(response.message || 'Email verified successfully!');
        
        // Redirect to login after 3 seconds
        setTimeout(() => {
          navigate(ROUTES.LOGIN, { 
            state: { message: 'Email verified! Please log in.' } 
          });
        }, 3000);
      } catch (error) {
        setStatus('error');
        setMessage(
          error.response?.data?.error || 
          'Failed to verify email. The link may be expired or invalid.'
        );
      }
    };

    verifyEmail();
  }, [searchParams, navigate]);

  return (
    <div className="auth-page">
      <div className="auth-container">
        <div className="auth-card">
          <h1>Email Verification</h1>
          
          {status === 'verifying' && (
            <div className="verification-status">
              <LoadingSpinner size="large" />
              <p>Verifying your email address...</p>
            </div>
          )}

          {status === 'success' && (
            <div className="verification-status success">
              <div className="success-icon">✓</div>
              <h2>Email Verified!</h2>
              <p>{message}</p>
              <p className="redirect-message">
                Redirecting to login page...
              </p>
            </div>
          )}

          {status === 'error' && (
            <div className="verification-status error">
              <div className="error-icon">✗</div>
              <h2>Verification Failed</h2>
              <p>{message}</p>
              <div className="verification-actions">
                <Link to={ROUTES.LOGIN} className="btn btn-primary">
                  Go to Login
                </Link>
                <Link to={ROUTES.REGISTER} className="btn btn-secondary">
                  Register Again
                </Link>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default VerifyEmailPage;
